module.exports = __webpack_public_path__ + "static/cloudbolt-3ca51b7a7643572efb527365bf97bde9.png";